import React from "react";
import { AlertInfo } from "../../../common/Alert";
import { getImage, formatCurrency } from "../../../../utils/Utils";
import Empty from "../../../../assets/images_td/appImages/category.png";
import { useAppDispatch, useAppSelector } from "../../../../redux/hook";
import { Color } from "../../../../utils/theme";
import Swal from "sweetalert2";
import {
  CartItemType,
  decrement,
  increment,
  removeCartItem,
} from "../../../../redux/slice/useCartSlice";
import { getVendeur } from "../../../HomePage/HomePage";

function PanierItemTable() {
  const Vendeur = getVendeur();
  const dispatch = useAppDispatch();
  const { cartItems } = useAppSelector((state) => state.cart);

  const supprimerDuPanier = async (produitASupprimer: CartItemType) => {
    await Swal.fire({
      title:
        "Êtes-vous sûr(e) de vouloir supprimer ce produit de votre panier ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
      showLoaderOnConfirm: true,
      iconColor: Color.themeColor,
      confirmButtonColor: Color.success,
      preConfirm: async () => {
        return await dispatch(removeCartItem(produitASupprimer));
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result: any) => {
      if (result.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: `Produit supprimé avec succès !`,
          iconColor: Color.success,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  };

  const getItemImage = (row: CartItemType) => {
    const cell = row?.produit;
    if (!cell) return "";
    if (cell?.type === "taille_unique") {
      return cell?.images?.length ? cell.images[0].image : "";
    }
    if (row?.variations?.length && row.variations[0]?.images?.length) {
      return row.variations[0].images[0].image;
    }
    return cell?.images?.length ? cell.images[0].image : "";
  };

  if (!cartItems?.length) {
    return (
      <div className="panier-empty-wrapper">
        <AlertInfo message="Votre panier est vide" />
      </div>
    );
  }

  return (
    <div className="panier-cards-list">
      {cartItems.map((row: CartItemType) => (
        <div
  key={`${row?.produit?.id}-${row?.variations?.[0]?.id ?? "u"}`}
  className="panier-card-row"
>
  <div className="panier-card-image">
    <img
      loading="lazy"
      src={getItemImage(row) ? getImage(getItemImage(row)) : Empty}
      alt={row?.produit?.nom ?? ""}
      className="panier-card-img"
    />
  </div>

  <div className="panier-card-info">
    <p className="panier-card-name mb-1">
      {row?.produit?.nom}
      {row?.variations?.[0]?.taille ? ` - ${row.variations[0].taille}` : ""}
    </p>
    <p className="panier-card-price mb-0">
      {formatCurrency(row?.prix ?? 0, Vendeur?.devise)}
    </p>
  </div>

  <div className="panier-card-qty">
    <div className="row-quantity">
      <button
        type="button"
        className="action-btn"
        disabled={row?.quantite <= 1}
        onClick={() => dispatch(decrement(row))}
      >
        −
      </button>
      <span className="qty_wrapper">{row?.quantite}</span>
      <button
        type="button"
        className="action-btn"
        disabled={row?.quantite >= (row?.stock ?? 999)}
        onClick={() => dispatch(increment(row))}
      >
        +
      </button>
    </div>
  </div>

  <div className="panier-card-total">
    {formatCurrency((row?.prix ?? 0) * (row?.quantite ?? 0), Vendeur?.devise)}
  </div>

  <button
    type="button"
    className="panier-card-remove"
    aria-label="Supprimer du panier"
    onClick={() => supprimerDuPanier(row)}
  >
    ×
  </button>
</div>
      ))}
    </div>
  );
}

export default PanierItemTable;